import { render, staticRenderFns } from "./AddPhoneModal.vue?vue&type=template&id=70445746"
import script from "./AddPhoneModal.vue?vue&type=script&lang=js"
export * from "./AddPhoneModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports